import React, { useState } from 'react'

import { useTranslation } from 'react-i18next'
import { Trash } from 'Assets/icons/Trash'
import { ThreeDots } from 'Assets/icons/ThreeDots'
import { ConfirmationModal } from 'Components/Elements/ConfirmationModal/ConfirmationModal'
import { User } from 'Types/User'
import { EditBoard } from 'Assets/icons/EditBoard'
import { PopOver } from 'Components/Elements/PopOver/PopOver'
import { IconButton } from 'Components/Elements/IconButton/IconButton.styled'
import * as Popover from '@radix-ui/react-popover'
import { ExtraOptionPopOverStyled, ExtraOptionRow } from './ExtraOptionPopOver.styled'
import { useDeleteUser } from 'Features/accountSettings/api/deleteUsers'
import { AddEditUserModal } from 'Features/accountSettings/components/UserManagement/AddEditUserModal/AddEditUserModal'
import { useAppStore } from 'Stores/appStoreModuleFed'

type ExtraOptionsModalProps = {
  user: User
  isOpen: boolean
  onOpenChange: (open) => void
  notAcceptInvitation: boolean
}

const Trigger = () => {
  return (
    <Popover.Trigger asChild>
      <IconButton
        aria-label="more-options"
        css={{ right: '30px', top: '20px', position: 'absolute' }}
      >
        <ThreeDots />
      </IconButton>
    </Popover.Trigger>
  )
}

export const ExtraOptionPopOver = ({
  user,
  onOpenChange,
  isOpen,
  notAcceptInvitation,
}: ExtraOptionsModalProps) => {
  const { t } = useTranslation('accountSettings')
  const [showConfirmationModal, setShowConfirmationModal] = useState<boolean>(false)
  const [showAddEditModal, setShowAddEditModal] = useState<boolean>(false)
  const { mutate, isLoading } = useDeleteUser()
  const { showToaster } = useAppStore()

  const deleteUser = () => {
    mutate(user, {
      onSuccess: () => {
        setShowConfirmationModal(false)
        showToaster(t('add_new_user_modal.deleted_successfully'), 'success')
      },
    })
  }

  return (
    <PopOver trigger={<Trigger />} isOpen={isOpen} onOpenChange={onOpenChange}>
      <ExtraOptionPopOverStyled id="extra-options-modal">
        {notAcceptInvitation ? null : (
          <ExtraOptionRow
            onClick={() => {
              setShowAddEditModal(true)
            }}
          >
            <EditBoard /> {t('user_management.edit')}
          </ExtraOptionRow>
        )}
        <ExtraOptionRow
          onClick={() => {
            setShowConfirmationModal(true)
          }}
        >
          <Trash /> {t('user_management.remove')}
        </ExtraOptionRow>
      </ExtraOptionPopOverStyled>
      {showAddEditModal && (
        <AddEditUserModal
          isOpen={showAddEditModal}
          onOpenChange={() => {
            setShowAddEditModal(false)
          }}
          user={user}
        />
      )}
      <ConfirmationModal
        isOpen={showConfirmationModal}
        ctaAction={deleteUser}
        title={t('user_management.remove_title')}
        description={t('user_management.remove_desc', { name: user.name })}
        ctaText={t('user_management.yes_remove')}
        loading={isLoading}
        onOpenChange={() => {
          setShowConfirmationModal(false)
        }}
      />
    </PopOver>
  )
}
